const workbench = {
  dashboardTitle: '招聘数据中心',
  operatingDesk: '工作台',
  compactGreeting: '{greeting}，{name}',
  compactSubtitle: '查看当前额度、人才库和常用入口，继续推进今天的招聘任务。',
  compactSubtitlePool: [
    '今天也把好人才往前推进一步。',
    '优秀候选人不会等人，先把关键跟进排上。',
    '多看一位候选人，就多一个靠谱机会。',
    '把筛选做细，后面的沟通会轻很多。',
    '先锁定高潜人才，再让流程自动往前跑。',
    '好招聘靠节奏，今天继续稳稳推进。',
    '别让合适的人才卡在待处理里。',
    '每一次精准触达，都是在帮团队缩短招聘周期。',
  ],
  realMetricsTitle: '当前可用数据',
  aiMatchPoints: 'AI积分',
  aiMatchPointsDesc: '用于岗位候选人匹配分析',
  jobQuotaCompactDesc: '当前可新建岗位额度',
  startChecklistTitle: '新手任务',
  startChecklistDesc: '按顺序完成任务，完成后自动解锁下一项。',
  availableJobCount: '可新建岗位数量',
  availableJobCountDesc: '当前可新建岗位额度',
  aiRecommendedTalent: 'AI 推荐人才',
  aiRecommendedTalentDesc: '累计推荐 85 分以上人才',
  outreachTalent: '外联人才',
  outreachTalentDesc: '累计已沟通人才',
  onboardingCreateJobTitle: '新建一个招聘项目',
  onboardingCreateJobDesc: '创建岗位、完成搜索策略，并推进一次人才匹配。',
  onboardingRecommendationTitle: 'EasyHire AI人才推荐 - 人才添加岗位',
  onboardingRecommendationDesc: '从 AI 推荐结果里添加 5 位候选人到岗位。',
  onboardingLinkedinTitle: 'LinkedIn自动化搜索匹配',
  onboardingLinkedinDesc: '启动一次 LinkedIn 自动化搜索，并回流匹配结果。',
  onboardingOutreachTitle: '自动化外联',
  onboardingOutreachDesc: '完成一次 InMail、Email 或添加好友的自动化触达。',
  onboardingReferralTitle: '推荐有礼',
  onboardingReferralDesc: '邀请好友通过专属链接新注册，首个有效邀请会完成此任务。',
  onboardingLocked: '待解锁',
  onboardingClaimReward: '领取奖励',
  onboardingRewardClaimed: '奖励已领取',
  rewardAiMatch400: 'AI积分 +400',
  rewardAiMatch200: 'AI积分 +200',
  rewardContact5: '联系积分 +5',
  rewardMembership7: '会员 +7天',
  rewardUnlockOutreach: '解锁外联流程',
  rewardReferralBundle: '进入推荐进度',
  taskDone: '已完成',
  taskInstall: '去安装',
  taskStart: '开始',
  taskOpen: '打开',
  taskView: '查看',
  taskExtensionTitle: '连接浏览器插件',
  taskExtensionDesc: '插件用于同步登录状态和执行 LinkedIn 页面操作。',
  taskCreateJobTitle: '创建招聘项目',
  taskCreateJobDesc: '用招聘对话生成一个岗位项目。',
  taskCreateJobDoneDesc: '已有 {count} 个岗位项目。',
  taskTalentTitle: '整理人才库',
  taskTalentDesc: '选择全部人才或具体分组管理候选人。',
  taskTalentDoneDesc: '人才库已有 {count} 位候选人。',
  taskPointsTitle: '检查积分余额',
  taskPointsDesc: '确认联系积分和 AI积分是否足够。',
  taskSettingsTitle: '配置基础内容',
  taskSettingsDesc: '维护邮件、模板和团队常用内容。',
  greetingMorning: '早上好',
  greetingNoon: '中午好',
  greetingAfternoon: '下午好',
  greetingEvening: '晚上好',
  greetingTipMorning: '早上好，开启努力满格的一天。',
  greetingTipNoon: '中午好，忙碌之余也别忘了补充能量。',
  greetingTipAfternoon: '下午好，适合把关键进展再往前推一步。',
  greetingTipEvening: '晚上好，把今天的重要进展稳稳收尾。',
  greetingTipLateNight: '夜深了，别忘了早些休息。',
  greetingWithName: '👋{greeting}，{name}',
  beijingTimeLabel: '北京时间 UTC+8',
  utcTimeLabel: '国际时间 UTC',
  weekThis: '本周',
  exportReport: '导出报告',
  quotaTitle: '用户权益',
  resumeImport: 'AI积分',
  resumeImportDesc: '简历导入功能即将上线，敬请期待',
  resumeImportPreviewDesc: '支持单份与批量两种导入模式，智能解析简历内容并自动提取关键信息。',
  resumeImportIndividual: '个人版导入',
  resumeImportBatch: '批量导入',
  contactPoints: '联系积分',
  contactPointsHint: '获取Email消耗1积分，获取手机号消耗2积分',
  contactPointsLow: '积分不足?',
  contactPointsRecharge: '充值',
  contactPointsRechargeTitle: '联系销售充值联系积分',
  contactPointsRechargeDesc: '当前联系积分不足，请扫描二维码联系销售充值联系积分。',
  pointsUnit: '积分',
  currentActivityTitle: '当前动态',
  candidatesInTalentPool: '人才库候选人',
  candidatesInTalentPoolDesc: '集中管理所有候选人，支持标签筛选与批量操作',
  jobManageCount: '可新建岗位数量',
  jobManageCountDesc: '升级成企业会员基础版享受无限岗位额度',
  metricsAddedFriends: '本周添加好友数',
  metricsAccepted: '本周通过数',
  metricsAcceptanceRate: '本周通过率',
  metricsPending: '当前未通过人数',
  metricsVsLastWeek: 'vs 上周',
  metricsRefresh: '刷新',
  delayedAcceptanceTitle: '延迟通过分析',
  delayedAcceptanceSubtitle: '本周通过的 75 人中，来源分布',
  delayedAcceptanceLegendThisWeek: '本周发送',
  delayedAcceptanceLegendLastWeek: '上周发送',
  delayedAcceptanceLegendEarlier: '更早发送',
  delayedAcceptanceLegendValue: '{count} 人 ({percentage}%)',
  delayedAcceptanceInsightLabel: '洞察：',
  delayedAcceptanceInsightText:
    'LinkedIn 招聘存在明显延迟转化，52% 的通过来自往期发送。建议保持稳定投放节奏。',
  weeklyComparisonTitle: '周度发送 & 通过对比',
  weeklyComparisonPeriod: '周期',
  weeklyComparisonSent: '发送数',
  weeklyComparisonAccepted: '通过数',
  weeklyComparisonPending: '未通过',
  weeklyComparisonRate: '通过率',
  weeklyComparisonThisWeek: '本周',
  weeklyComparisonLastWeek: '上周',
  weeklyComparisonTwoWeeksAgo: '上上周',
  weeklyComparisonInsightLabel: '趋势分析：',
  weeklyComparisonInsightText:
    '本周发送量较上周增长 25.4%，但通过率略有下降。建议优化候选人筛选标准。',
  aiToolsTitle: 'AI 招聘工具',
  aiToolAgentTitle: 'Recruiting AI 自动化搜索',
  aiToolAgentDesc:
    '输入招聘需求生成搜索策略，并按 Business / Sales / Recruiter 账号类型打开 LinkedIn 搜索。',
  aiToolAgentEnterpriseHint: '会员可用',
  aiToolJdTitle: '自然语言创建岗位',
  aiToolJdDesc: '用日常语言描述招聘需求，AI 自动解析并生成完整岗位信息。',
  aiToolMatchTitle: '岗位候选人匹配',
  aiToolMatchDesc: '候选人进入岗位后自动分析匹配分数、优势、风险与近期洞察。',
  aiToolMatchPreviewDesc:
    '基于岗位要求与候选人简历进行多维度分析，输出匹配分数、匹配等级、优势、风险与近期洞察，帮助团队快速判断优先跟进对象。',
  aiToolEnterpriseOnly: '企业版',
  zoomTip: '提示：按住 Ctrl + 鼠标滚轮 可缩放页面，获得最佳页面显示效果',
  extensionTip: '提示：暂未检测到插件，部分功能无法使用',
  extensionInstall: '点击安装插件',
  aiToolReportTitle: '岗位人才报表',
  aiToolReportDesc: '围绕岗位汇总候选人匹配结果，支持查看推荐理由、风险点与分析详情。',
  aiToolReportPreviewDesc:
    '基于岗位下候选人的匹配分析生成结构化人才报表，集中展示匹配分数、匹配等级、推荐优势、潜在风险与分析详情。',
  aiToolExportTitle: 'Excel 导出',
  aiToolExportDesc:
    '按人才库标签或岗位导出候选人信息，保留当前岗位、最近公司与匹配分析等关键字段。',
  aiToolExportPreviewDesc:
    '支持从人才库标签和岗位列表导出 Excel。岗位导出包含匹配分数、匹配等级、匹配优势、匹配风险、近期洞察与分析详情，标签导出聚焦候选人基础信息与履历字段。',
  helpTitle: '帮助与支持',
  helpCenter: '进入帮助中心 →',
  helpGuideTitle: '快速入门手册',
  helpGuideDesc: '完成账号类型、Extension、岗位与人才库的基础配置。',
  helpGuideContent:
    '1. 在个人设置中完善 LinkedIn 账号类型\n2. 安装并启用 EasyHire AI Extension，保持当前账号登录状态\n3. 创建岗位或人才库标签，明确需要收集的人才范围\n4. 使用 Recruiting AI 生成搜索策略，并启动对应账号类型的 LinkedIn 搜索\n5. 收集候选人后，在人才库或岗位中查看匹配分析、报表与 Excel 导出',
  helpVideoTitle: '视频教程',
  helpVideoDesc: '快速了解从搜索策略到候选人收集、匹配分析和导出的完整流程。',
  helpVideoEmpty: '视频教程正在筹备中，敬请期待！',
  helpFaqTitle: '常见问题 (FAQ)',
  helpFaqDesc: '自动化搜索、账号类型、积分和导出常见问题。',
  helpFaqContent:
    'Q: 联系积分如何扣除？\nA: 获取候选人 Email 消耗 1 积分，获取手机号消耗 2 积分。\n\n' +
    'Q: 自动化搜索为什么不可用？\nA: 自动化搜索需要有效会员，并依赖 EasyHire AI Extension 同步登录状态和执行 LinkedIn 招聘操作。\n\n' +
    'Q: LinkedIn 账号类型有什么影响？\nA: Business、Sales、Recruiter 会打开不同版本的 LinkedIn 搜索页面。建议先在个人设置中选择当前账号类型。\n\n' +
    'Q: 岗位导出和人才库标签导出有什么区别？\nA: 岗位导出包含匹配分数、匹配等级、优势、风险、近期洞察和分析详情；标签导出聚焦候选人基础信息与履历字段。\n\n' +
    'Q: AI 匹配有使用次数限制吗？\nA: 各版本均有月度/季度/年度 AI 匹配次数配额，具体请参考订阅页面。\n\n' +
    'Q: 如何获得更多积分？\nA: 可通过购买套餐获得积分，或邀请好友新注册并达成有效邀请，按第 1、3、5 档获得奖励。',
  helpContactTitle: '联系专属客服',
  helpContactDesc: '获取 1v1 操作指导与企业专属定制方案。',
  helpContactScan: '扫描二维码添加专属客服，获取 1v1 操作指导与企业专属定制方案。',
}

export default workbench
